import type { ReactNode } from "react";

/** Passo a passo numerado, com título opcional. Só apresentação: o conteúdo vem de quem usa. */
export function Steps({ heading, items }: { heading?: string; items: ReactNode[] }) {
  return (
    <section>
      {heading ? <h3 className="ds-steps__heading">{heading}</h3> : null}
      <ol className="ds-steps">
        {items.map((item, index) => <li key={index}>{item}</li>)}
      </ol>
    </section>
  );
}
